import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allEntCarrerasAction } from '../EntCarrerasAction';

const SelectFieldEntCarrerasComponent = ({
  onChange,
  data,
  value,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && entCarrerasStore.all.length === 0) {
        await allEntCarrerasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setItems(entCarrerasStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      entCarrerasStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(entCarrerasStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.carrera.name}`}>
        {CONST.carrera.label}
      </InputLabel>
      <Select
        id={CONST.carrera.name}
        value={value}
        labelId={`label_${CONST.carrera.name}`}
        label={CONST.carrera.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {items.map((el, index) => {
          return (
            <MenuItem key={`carrera-${index}`} value={el.id}>
              {el.carrera.nombre} ({el.modalidad})
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id="combo-box-demo-carreras"
      opt={items}
      type={CONST.carrera.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l={CONST.carrera.label}
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldEntCarrerasComponent;
